// account-ui catalog — locale pt (register: neutral, no tu/você commitment).
import en from './en';

const pt: typeof en = {
  common: {
    loading: 'A carregar…',
  },
  account: {
    brand: 'lumi HR',
    home: {
      title: 'A conta lumi HR',
      intro:
        'Esta página pertence à pessoa, não a um espaço de trabalho. Continua acessível mesmo quando um espaço de trabalho associado está bloqueado ou foi encerrado.',
      rightsTitle: 'O que é possível fazer aqui',
      rights: {
        takeout: 'Descarregar uma cópia dos dados assim que estiver preparada.',
        erasure:
          'Pedir a eliminação de um espaço de trabalho e dos respetivos dados, ou retirar um pedido submetido pela própria pessoa.',
        invoices: 'Consultar e descarregar as faturas de um espaço de trabalho administrado.',
        export:
          'Exportar um espaço de trabalho próprio — todos os seus dados num único arquivo cifrado.',
      },
      signInHint:
        'Tudo isto exige autenticação prévia. A ligação enviada por e-mail aponta apenas para esta página — nunca autentica ninguém.',
      workspaceHint:
        'Todo o resto – o trabalho diário e as definições – permanece no espaço de trabalho.',
    },
    signIn: {
      title: 'Iniciar sessão',
      intro:
        'Indique o endereço de e-mail do lumi HR e a palavra-passe. Não é preciso nomear um espaço de trabalho — mostramos aqueles a que a conta pertence.',
      email: 'Endereço de e-mail',
      password: 'Palavra-passe',
      submit: 'Iniciar sessão',
      failed: 'Não foi possível iniciar sessão com esse endereço de e-mail e essa palavra-passe.',
      passkey: 'Iniciar sessão com uma chave de acesso',
      passkeyHint:
        'Sem endereço de e-mail? Uma conta criada com um número de telemóvel inicia sessão com a respetiva chave de acesso.',
      passkeyFailed: 'Não foi possível iniciar sessão com essa chave de acesso.',
      operatorSecondFactor: 'Esta é uma conta de administração de sistema, que exige um segundo fator. Aqui, inicie sessão com uma chave de acesso; com palavra-passe e código de autenticação, inicie sessão na consola lumi.',
    },
    session: {
      signedInAs: 'Sessão iniciada como {email}.',
      signOut: 'Terminar sessão',
    },
    workspaces: {
      title: 'Espaços de trabalho',
      intro:
        'Os espaços de trabalho a que esta conta pertence. Um espaço bloqueado mantém-se nesta lista — é para isso que esta página existe.',
      emptyTitle: 'Sem espaços de trabalho',
      emptyBody:
        'Esta conta não pertence a nenhum espaço de trabalho. Se esperava encontrar um aqui, fale com quem enviou o convite.',
      loadFailed: 'Não foi possível carregar os espaços de trabalho.',
      ssoRequired:
        'Este espaço de trabalho exige o início de sessão único (SSO) da empresa. Inicie sessão a partir do próprio espaço de trabalho para usar estas ferramentas — aqui uma palavra-passe não o abre.',
      state: {
        active: 'Ativo',
        suspended: 'Bloqueado',
        provisioning: 'Em preparação',
        erased: 'Eliminado',
        unavailable: 'Indisponível',
      },
      hint: {
        active: 'Este espaço de trabalho está a funcionar normalmente.',
        suspended: 'Este espaço de trabalho está bloqueado. Ainda assim, os direitos podem ser exercidos aqui.',
        provisioning: 'Este espaço de trabalho ainda está a ser preparado.',
        erased:
          'Este espaço de trabalho e os respetivos dados foram eliminados. Restam apenas as faturas, porque somos obrigados a conservá-las.',
        unavailable: 'Este espaço de trabalho está de momento inacessível.',
      },
    },
    invoices: {
      open: 'Mostrar as faturas',
      hide: 'Ocultar as faturas',
      empty: 'Não existem faturas para este espaço de trabalho.',
      loadFailed: 'Não foi possível carregar as faturas deste espaço de trabalho.',
      download: 'Descarregar o PDF',
      documentMissing: 'Esta fatura não tem qualquer documento para descarregar.',
      documentUnavailable:
        'De momento não é possível obter o documento da fatura. Continua a existir — tente novamente daqui a pouco.',
      downloadFailed: 'Não foi possível descarregar essa fatura.',
    },
    takeout: {
      title: 'A cópia dos seus dados',
      what:
        'Esta é uma cópia dos dados pessoais que este espaço de trabalho conserva a seu respeito, acompanhada de uma explicação sobre a finalidade da sua utilização.',
      availableUntil:
        'Pode descarregá-la até {date}. Depois é eliminada automaticamente, por isso guarde-a antes dessa data se pretender conservá-la.',
      download: 'Descarregar os meus dados',
      none: 'Não está aqui à sua espera qualquer cópia dos seus dados.',
      expired:
        'A cópia preparada podia ser descarregada até {date}. Entretanto foi eliminada, tal como foi anunciado.',
      howToAsk:
        'Pode pedir uma cópia a qualquer momento: contacte o espaço de trabalho que conserva os seus dados. Assim que estiver pronta, enviamos uma mensagem de correio eletrónico e pode descarregá-la nesta página.',
      loadFailed: 'Não foi possível verificar se está aqui à sua espera uma cópia dos seus dados.',
      downloadUnavailable:
        'De momento não é possível obter a sua cópia. Continua a existir — tente novamente daqui a pouco.',
      downloadFailed: 'Não foi possível descarregar a cópia dos seus dados.',
    },
    export: {
      title: 'Exportar este espaço de trabalho',
      intro:
        'Descarregue tudo o que existe neste espaço de trabalho num único arquivo cifrado. Também funciona enquanto o espaço está bloqueado — é precisamente para isso que esta página existe.',
      contents:
        'O arquivo contém o registo de cada pessoa, todos os ficheiros carregados no espaço de trabalho e as suas ligações a outros serviços. Trate-o como o próprio espaço de trabalho: guarde-o em local seguro e não o entregue a ninguém que não deva ver tudo. O arquivo inclui também, para Pessoal, Recrutamento e Tempo, um documento HR Open Standards (HR-JSON) — o formato partilhado para levar os dados para outro fornecedor.',
      passphraseWarning:
        'A palavra-passe é escolhida por si e nunca é guardada por nós. Sem ela o arquivo deixa de poder ser aberto — nem por si, nem por nós.',
      passphraseLabel: 'Palavra-passe do arquivo',
      passphraseHint: 'No mínimo {min} caracteres.',
      confirmLabel: 'Repita a palavra-passe',
      submit: 'Iniciar a exportação',
      started:
        'A exportação começou. A preparação demora algum tempo — volte a esta página e atualize a lista.',
      errorTooShort: 'Escolha uma palavra-passe com pelo menos {min} caracteres.',
      errorMismatch: 'As duas palavras-passe não são iguais. Verifique-as e tente novamente.',
      errorCannotStart:
        'Não é possível iniciar a exportação neste momento: pode já estar em curso uma exportação deste espaço de trabalho, ou o espaço de trabalho pode estar a ser encerrado.',
      errorTooMany:
        'Este espaço de trabalho já iniciou hoje todas as exportações a que tem direito. Tente novamente amanhã.',
      errorGeneric:
        'Não foi possível iniciar a exportação. Nada foi alterado — tente novamente daqui a pouco.',
      listTitle: 'Exportações deste espaço de trabalho',
      refresh: 'Atualizar',
      loadFailed: 'Não foi possível carregar as exportações deste espaço de trabalho.',
      empty: 'Ainda não foi feita nenhuma exportação deste espaço de trabalho.',
      startedAt: 'Iniciada a {date}',
      availableUntil: 'Pode ser descarregada até {date}',
      download: 'Descarregar o arquivo',
      downloadGone: 'Este arquivo já não está disponível. Inicie uma nova exportação para obter outro.',
      downloadUnavailable:
        'De momento não é possível obter o arquivo. Continua a existir — tente novamente daqui a pouco.',
      downloadFailed: 'Não foi possível descarregar o arquivo.',
      status: {
        requested: 'Em fila de espera',
        exporting: 'Em preparação',
        exported: 'Pronta a descarregar',
        failed: 'Falhou',
        expired: 'Eliminada',
        unknown: 'Estado desconhecido',
      },
    },
    erasure: {
      file: 'Pedir a eliminação deste espaço de trabalho',
      loadFailed:
        'Não foi possível verificar se foi pedida a eliminação deste espaço de trabalho.',
      confirmTitle: 'Pedir a eliminação deste espaço de trabalho?',
      confirmWhatGoes:
        'Tudo o que existe em «{workspace}» seria eliminado definitivamente: cada processo de pessoal, cada candidatura, cada documento, cada registo de horas e cada definição, para todas as pessoas que nele trabalham. Depois disso nada poderá ser recuperado.',
      confirmProcess:
        'Trata-se de um pedido; ainda não é eliminado nada. Analisamos o pedido e, depois de aprovado, começa um prazo de espera. O pedido pode ser retirado a qualquer momento enquanto a eliminação não tiver começado.',
      invoicesKept: 'As faturas mantêm-se, porque a lei obriga-nos a guardá-las.',
      reason: 'Motivo (opcional)',
      keep: 'Não, manter este espaço de trabalho',
      confirmSubmit: 'Sim, pedir a eliminação',
      pendingReview:
        'Foi pedida a eliminação deste espaço de trabalho. Estamos a analisar o pedido.',
      pendingUntil:
        'Foi pedida a eliminação deste espaço de trabalho. Será eliminado depois de {date}.',
      paymentsPending:
        'Este espaço de trabalho está marcado para eliminação porque a conta não foi paga.',
      paymentsPendingUntil:
        'Este espaço de trabalho está marcado para eliminação porque a conta não foi paga. Será eliminado depois de {date}.',
      paymentsSettle:
        'O pagamento da fatura em dívida trava esta eliminação. Também é possível pedir a eliminação: nesse caso ela avança independentemente do pagamento.',
      paymentsCannotWithdraw:
        'Esta eliminação foi marcada porque a conta não foi paga, pelo que não pode ser retirada aqui. Pague a fatura em dívida para a travar.',
      confirmTakeover:
        'Este espaço de trabalho já está marcado para eliminação porque a conta não foi paga. O seu pedido assume essa eliminação: pagar a fatura deixa de a travar.',
      withdraw: 'Retirar o pedido de eliminação',
      withdrawTitle: 'Retirar o pedido de eliminação?',
      withdrawBody:
        'Este espaço de trabalho e todos os seus dados são mantidos. É possível voltar a pedir a eliminação a qualquer momento.',
      confirmType: 'Escrever o nome do espaço de trabalho ({name}) para confirmar',
      confirmMismatch:
        'O nome introduzido não corresponde a este espaço de trabalho. É preciso verificá-lo e tentar novamente.',
      tooLate: 'A eliminação já começou e não pode ser retirada.',
      conflict: 'Este espaço de trabalho já está a ser eliminado, por isso nada mudou.',
      nothingOpen: 'Não existe nenhum pedido de eliminação para retirar neste espaço de trabalho.',
      filed: 'O pedido de eliminação foi registado. Vamos analisá-lo.',
      withdrawn: 'O pedido de eliminação foi retirado. Este espaço de trabalho mantém-se.',
    },
    closure: {
      title: 'Encerrar a conta lumi',
      intro:
        'Trata-se aqui da própria conta lumi — do acesso — e não de um dos espaços de trabalho acima.',
      open: 'Encerrar a minha conta',
      confirmTitle: 'Encerrar a conta lumi?',
      whatGoes:
        'O acesso deixa de existir: este endereço de e-mail e esta palavra-passe deixam de funcionar, uma autenticação única da empresa que esteja associada é desligada e a conta sai de todos os espaços de trabalho a que pertence. Desaparece também o que resultou da utilização da lumi: eliminamos as conversas com o assistente, as notificações que enviámos e as respetivas definições, e retiramos o nome e os textos escritos dos pedidos de apoio e das mensagens enviadas para nós.',
      whatStays:
        'Os dados junto de cada entidade empregadora ficam com essa entidade. A lumi opera os sistemas, mas cada empresa continua responsável pelos seus dados de pessoal e de candidatura, e encerrar a conta aqui não os elimina. Se um espaço de trabalho estiver abrangido por um processo judicial ou por uma investigação oficial, temos de conservar o que lhe está associado: os pedidos, as mensagens e as conversas desse espaço ficam até isso terminar.',
      howToErase:
        'Para que os dados guardados por uma entidade empregadora sejam eliminados, o pedido deve ser dirigido diretamente a essa empresa. É a empresa que responde a esse pedido, e parte dos dados tem de ser conservada por imposição legal durante mais algum tempo.',
      noUndo:
        'O encerramento não pode ser anulado e nada fica pendente. É possível voltar a registar-se a qualquer momento com o mesmo endereço de e-mail — será uma conta nova e vazia.',
      confirmType: 'Escreva o endereço de e-mail ({email}) para confirmar',
      confirmMismatch: 'Este não é o endereço de e-mail desta conta. Verifique-o e tente novamente.',
      keep: 'Não, manter a conta',
      confirmSubmit: 'Sim, encerrar a conta',
      doneTitle: 'A conta está encerrada',
      doneBody:
        'A sessão terminou e este endereço de e-mail e esta palavra-passe já não dão acesso a nada na lumi. As conversas com o assistente e as notificações que enviámos foram eliminadas, e os pedidos de apoio e as mensagens enviadas para nós já não contêm o nome nem os textos escritos.',
      doneStays:
        'Os dados junto de cada entidade empregadora ficam com essa entidade e continuam a ser geridos por ela. Para que sejam eliminados, o pedido deve ser dirigido diretamente a cada empresa. E se um espaço de trabalho estiver abrangido por um processo judicial ou por uma investigação oficial, o que lhe está associado permanece connosco até isso terminar.',
      doneMailed: 'Enviámos uma confirmação por e-mail.',
      doneNotMailed:
        'Não foi possível enviar o e-mail de confirmação. A conta foi encerrada na mesma.',
      blockedTitle: 'Estes espaços de trabalho ainda precisam de um proprietário',
      blockedBody:
        'Esta conta é a única proprietária dos espaços de trabalho abaixo, por isso ainda não a podemos encerrar. Um espaço sem proprietário só pode ser reaberto por nós, e todas as pessoas que nele trabalham ficariam sem acesso aos seus próprios dados.',
      blockedTransfer:
        'Entregue «{name}»: abra esse espaço de trabalho e transfira aí a propriedade para outro membro.',
      blockedErasure: 'Ou peça a eliminação de «{name}» na lista de espaços de trabalho acima.',
      blockedReturn:
        'Esta tentativa não fica registada. Quando nenhum espaço de trabalho precisar desta conta como proprietária, volte a esta página e encerre a conta nessa altura.',
      unavailable:
        'O encerramento de contas não está a funcionar neste momento. Nada foi alterado — tente novamente dentro de momentos.',
      alreadyClosed: 'Esta conta já está encerrada.',
      failed: 'Não resultou. A conta não foi encerrada — tente novamente dentro de momentos.',
      confirmTypePhone: 'Escreva o número de telemóvel completo ({phone}) para confirmar',
      confirmMismatchPhone:
        'Este não é o número de telemóvel desta conta. Verifique-o e tente novamente.',
      whatGoesPhone:
        'O acesso deixa de existir: as chaves de acesso e este número de telemóvel deixam de funcionar, uma autenticação única da empresa que esteja associada é desligada e a conta sai de todos os espaços de trabalho a que pertence. Desaparece também o que resultou da utilização da lumi: eliminamos as conversas com o assistente, as notificações que enviámos e as respetivas definições, e retiramos o nome e os textos escritos dos pedidos de apoio e das mensagens enviadas para nós.',
      noUndoPhone:
        'O encerramento não pode ser anulado e nada fica pendente. Um espaço de trabalho pode voltar a enviar um convite para o mesmo número — será uma conta nova e vazia.',
      doneBodyPhone:
        'A sessão terminou e as chaves de acesso e este número de telemóvel já não dão acesso a nada na lumi. As conversas com o assistente e as notificações que enviámos foram eliminadas, e os pedidos de apoio e as mensagens enviadas para nós já não contêm o nome nem os textos escritos.',
      doneScreenOnly: 'Este ecrã é a confirmação — não enviamos nenhuma por SMS.',
    },
  },
};

export default pt;
